import {
  TeamMemberRequest as SharedTeamMemberRequest,
  TeamMemberRequestStatus as SharedTeamMemberRequestStatus,
  TEAM_MEMBER_REQUEST_STATUSES as SharedTeamMemberRequestStatuses,
} from "shared/dist/types/TeamMemberRequest";

export type TeamMemberRequestStatus = SharedTeamMemberRequestStatus;
export const TEAM_MEMBER_REQUEST_STATUSES = SharedTeamMemberRequestStatuses;

export default interface TeamMemberRequest extends SharedTeamMemberRequest {}
